import { Box, FormControlLabel, Typography } from "@mui/material";
import Loading from "components/common/Loading";
import AnnotationCard from "components/engagement/notes/AnnotationCard";
import useIsMobile from "components/hooks/useIsMobile";
import { Advisor } from "protogen/common_pb";
import { ReactNode, useEffect, useState } from "react";
import {
  useListAdvisorAnnotations,
  useUpdateAdvisorAnnotation,
} from "services/admin";
import AddAdvisorAnnotation from "./AddAdvisorAnnotation";
import Checkbox from "components/common/Checkbox";
import ChangeEventCard from "components/engagement/notes/ChangeEventCard";
import { ListAdvisorAnnotationsRequest } from "protogen/admin_service_pb";
type Props = {
  advisor: Advisor;
};

export default ({ advisor }: Props) => {
  const { data: annotations, loading, request } = useListAdvisorAnnotations();
  const { request: deleteAnnotation } = useUpdateAdvisorAnnotation();
  const [includeChangeEvents, setIncludeChangeEvents] = useState(false);
  const isMobile = useIsMobile();
  useEffect(() => {
    request(
      new ListAdvisorAnnotationsRequest({
        advisorRef: advisor.ref,
        includeChangeEvents: includeChangeEvents,
      }),
    );
  }, [advisor.ref]);

  // Merge results
  const feedEntries: [number, ReactNode][] = [
    ...(annotations?.annotations || []).map(
      (annotation): [number, ReactNode] => [
        Number(annotation.lastUpdatedSec),
        <AnnotationCard
          key={`annotation-${annotation.ref}`}
          annotation={annotation}
          handleDelete={async () => {
            await deleteAnnotation({
              annotationRef: annotation.ref,
              delete: true,
            });
            await request(
              new ListAdvisorAnnotationsRequest({
                advisorRef: advisor.ref,
                includeChangeEvents: includeChangeEvents,
              }),
            );
          }}
        />,
      ],
    ),
    ...(annotations?.changeEvents || []).map(
      (annotation): [number, ReactNode] => [
        Number(annotation.lastUpdatedSec),
        <ChangeEventCard
          key={`annotation-${annotation.ref}`}
          annotation={annotation}
        />,
      ],
    ),
  ];
  feedEntries.sort((a, b) => b[0] - a[0]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        gap: "24px",
        borderTop: "1px solid #E2E3E4",
        padding: isMobile ? "20px 0 0" : "20px 0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="bodyHeavy">Notes</Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={includeChangeEvents}
                onChange={(e) => {
                  setIncludeChangeEvents(e.target.checked);
                  request(
                    new ListAdvisorAnnotationsRequest({
                      advisorRef: advisor.ref,
                      includeChangeEvents: e.target.checked,
                    }),
                  );
                }}
                size="small"
              />
            }
            label="Change events"
          />
        </Box>
        <AddAdvisorAnnotation
          advisorRef={advisor.ref}
          placeholder="Add a note"
          noteTypes={["note", "billing", "screen", "onboarding"]}
          includeFlags={false}
          forceOpen={false}
          onUpdate={async () => {
            await request(
              new ListAdvisorAnnotationsRequest({
                advisorRef: advisor.ref,
                includeChangeEvents: includeChangeEvents,
              }),
            );
          }}
        />
        {loading && <Loading />}
        {feedEntries.map((entry) => entry[1])}
      </Box>
    </Box>
  );
};
